import { render, staticRenderFns } from "./profileMdrSettings.vue?vue&type=template&id=440faab5"
import script from "./profileMdrSettings.vue?vue&type=script&lang=js"
export * from "./profileMdrSettings.vue?vue&type=script&lang=js"
import style0 from "./profileMdrSettings.vue?vue&type=style&index=0&id=440faab5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports